import axios from 'axios';

export default {
	pre_insertar(p_email, p_usuario, p_pricodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_proveedores.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_pricodigo": p_pricodigo
				  })
			})
	},

	insertar(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_proveedores.insertar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_pricodigo": datosFormulario.pricodigo,
					"p_prinombre": datosFormulario.prinombre,
					"p_pricodnum": datosFormulario.pricodnum,
					"p_privadirec": datosFormulario.privadirec,
					"p_priactivo": datosFormulario.priactivo,
					"p_pritipoinf": datosFormulario.pritipoinf
				  })
			})
	},

	buscar(p_email, p_usuario, p_pricodigo, p_tiporec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_proveedores.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_pricodigo": p_pricodigo,
					"p_tiporec": p_tiporec
				  })
			})
	},

	modificar(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_proveedores.modificar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_pricodigo": datosFormulario.pricodigo,
					"p_prinombre": datosFormulario.prinombre,
					"p_pricodnum": datosFormulario.pricodnum,
					"p_privadirec": datosFormulario.privadirec,
					"p_priactivo": datosFormulario.priactivo,
					"p_pritipoinf": datosFormulario.pritipoinf
				  })
			})
	},

	eliminar(p_email, p_usuario, p_pricodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_proveedores.eliminar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_pricodigo": p_pricodigo
				  })
			})
	},

	activar(p_email, p_usuario, p_pricodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_proveedores.activar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_pricodigo": p_pricodigo
				  })
			})
	}
}